import ko from 'vuetify/lib/locale/ko'
import global_config from '@/../config.json'

// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 닫기
export default {
  ...ko,
  __General: {
    submit: '제출'
  },
  __InitialLoading: {
    connecting: '연결 중...'
  },
  __ChatBubbleAi: {
    default_answer_by: global_config.default_answer_by_ko || 'AI가 생성한 답변',
    default_answer_desc: global_config.default_answer_desc_ko || 'AI가 생성한 답변',
    answer_by_mrc: 'MRC에 의한 답변',
    mrc_answer_desc: 'MRC(기계 독해)는 텍스트 문서를 스캔하고 텍스트에서 의미를 추출합니다',
    answer_by_chatGPT: global_config.answer_by_chatGPT_ko || 'ChatGPT에 의한 답변',
    chatgpt_answer_desc: global_config.chatgpt_answer_desc_ko || 'ChatGPT는 OpenAI에서 개발한 AI 챗봇으로, 자연어 처리를 사용하여 인간과 같은 대화를 생성합니다.',
    prompt_bar_message: '이 콘텐츠가 도움이 되었습니까?',
    comment_dialog: {
      title: '평가 이유를 공유해 주시겠습니까?',
      yes: '예',
      no: '아니요',
      placeholder: '여기에 댓글을 작성하세요',
      remaining_character: '남은 문자 수: {0}/{1}',
      submit: '제출',
      closing: '댓글 감사합니다!'
    }
  }
}
